import React from 'react';
import { Prism as SyntaxHighlighter } from 'react-syntax-highlighter';
import { vscDarkPlus } from 'react-syntax-highlighter/dist/esm/styles/prism';
import CopyButton from './CopyButton';

const CodeBlock = ({ code, language = 'json', title = 'Code' }) => {
  // Format JSON if it's an object
  const formattedCode = typeof code === 'object'
    ? JSON.stringify(code, null, 2)
    : code;

  return (
    <div className="code-block-container">
      <div className="code-block-header">
        <span className="code-block-title">{title}</span>
        <CopyButton text={formattedCode} label="Copy" />
      </div>
      <div className="code-block-content">
        <SyntaxHighlighter
          language={language}
          style={vscDarkPlus}
          customStyle={{
            margin: 0,
            padding: 'var(--space-md)',
            background: 'transparent',
            fontSize: '0.85rem',
            lineHeight: '1.5',
          }}
          codeTagProps={{
            style: {
              fontFamily: 'var(--font-mono)',
            }
          }}
        >
          {formattedCode}
        </SyntaxHighlighter>
      </div>
    </div>
  );
};

export default CodeBlock;
